import { useQuery } from '@tanstack/react-query'

import { axios, ExtractFnReturnType, QueryConfig } from '@apps-common/lib'
import { IMMSiteListModel } from '@apps-common/types/my-monitoring'

export const QUERY_KEY_MY_MONITORING_GET_SITE_LIST = () => ['getMyMonitoringSiteList'].filter(Boolean)

const getSiteList = async (): Promise<IMMSiteListModel[]> => axios.get('/my-monitoring/Sites/GetSites').then((res) => res.data?.data)

type QueryFnType = typeof getSiteList

type Props = {
  config?: QueryConfig<QueryFnType>
}

export const useMyMonitoringGetSiteList = ({ config }: Props) =>
  useQuery<ExtractFnReturnType<QueryFnType>>({
    ...{ ...config, cacheTime: 0 },
    queryKey: QUERY_KEY_MY_MONITORING_GET_SITE_LIST(),
    queryFn: () => getSiteList()
  })
